import http from '@/support/plugin/axios'

export const

getInfoBySubdomain = () => {
    let subdomain;

    if (window.location.host.endsWith(".lity.com.br")) {
        subdomain = window.location.host.split(".")[0]
    } else {
        subdomain = window.location.host
    }

    return http.get(`companies?subdomain=${subdomain}`)
},

//Notification quantity:
getUnreadNotificationsQuantityByCurrentContactIdAndCompanyId = ( companyId ) => http.get(`companies/${companyId}/contacts/current/unread-notifications-quantity`),

//User points:
getRemainingPointsByCompanyIdAndCurrentContactId = ( companyId ) => http.get(`companies/${companyId}/contacts/current/remaining-points`),

//Dinheiro economizado:
getSavedMoneyByCompanyIdAndCurrentContactId = ( companyId ) => http.get(`/companies/${companyId}/contacts/current/offers/saved-money`),

//Banner
    //Get banner
    getHomeBannersByCompanyId = ( companyId ) => http.get(`companies/${companyId}/home-banners`),

//Obter foto do usuário
getImageByCurrentId = () => http.get('contacts/current/image')